import AOS from 'aos';
import React, { useEffect } from 'react';
import styled from 'styled-components';
import { device } from '../../../utils/constants';
import LayoutMenu from '../landing-news/home/layoutHome';
import CinemaLab from './CinemaLab';
import ContactLab from './ContactLab';
import HeaderLab from './HeaderLab';
import ServiceLab from './ServiceLab';
import TheEdgeLab from './TheEdgeLab';
import TheTeamLab from './TheTeamLab';
import VerticalLab from './VerticalLab';
import WhoWeAreLab from './WhoWeAreLab';

const Body = styled.div`
  width: 70%;
  margin: 0 auto;
  font-family: 'FuturaLigth', Helvetica, Arial, sans-serif;
  box-sizing: border-box;
  --lab-pad-x: clamp(1.25rem, 4vw, 3rem);

  @media ${device.mobile} {
    width: 80%;
    max-width: 100%;
    padding-left: clamp(1rem, 5vw, 1.5rem);
    padding-right: clamp(1rem, 5vw, 1.5rem);
  }
`;

const LabNew = () => {
  useEffect(() => {
    AOS.refresh();
  }, []);

  return (
    <LayoutMenu menuBlack={false}>
      <Body>
        <HeaderLab />
        <WhoWeAreLab />
        <TheEdgeLab />
        <TheTeamLab />
        <VerticalLab />
        <CinemaLab />
        <ServiceLab />
        <ContactLab />
      </Body>
    </LayoutMenu>
  );
};

export default LabNew;
